import { useMemo, useState } from 'react';
import { DataTable } from 'src/portal/shared-compat/DataTable/DataTable';
import { useServerDataTable } from 'src/portal/shared-compat/DataTable/hooks';
import { useRmxServiceApi } from '../api';
import { useModal } from '../../hooks/useModal';
import { nullIfUndefined } from '../../utils';
import { partHistoryTableDef } from '../RmxServiceTableDefinitions/PartHistoryDefinition';
import type { PartHistory } from '../Service.types';

interface PartsTableInterface {
  filterByAssetId: number | null;
  filterBySiteId: number | null;
}
export function UsePartsTable(props?: PartsTableInterface) {
  const api = useRmxServiceApi();
  const partsModal = useModal<{ resource: PartHistory }>();
  const [partsDateFilter, setPartsDateFilter] = useState<number | null | string>(null);

  const partHistoryColumn = useMemo(() => partHistoryTableDef(), []);

  const partsTable = useServerDataTable({
    queryKey: ['parts', partsDateFilter],
    columns: partHistoryColumn,
    initialSorting: [{ desc: true, id: 'activityDate' }],
    getRows: async (params) => {
      return await api.getPartHistory({
        ...params,
        siteId: nullIfUndefined(props?.filterBySiteId),
        assetId: nullIfUndefined(props?.filterByAssetId),
        daysFilter: partsDateFilter
      });
    }
  });

  return { partsTable, partsModal, partsDateFilter, setPartsDateFilter };
}

export function PartsTable(props: PartsTableInterface) {
  const { partsTable } = UsePartsTable(props);

  return (
    <div>
      <DataTable table={partsTable} />
    </div>
  );
}
